import { observable, computed, action } from 'mobx';
import { persist } from 'mobx-persist';

import { zh_CN, en_US } from '~/locales/';
import antd_en_US from 'antd/lib/locale-provider/en_US';

const breadcrumbItems = {
  'home': {
    link: '/',
    textKey: 'live_breadcrumb_home',
  },
  'live': {
    link: '/live',
    textKey: 'live_breadcrumb_live',
  },
  'weibo_streams': {
    link: '/live/weibo',
    textKey: 'live_breadcrumb_weibo',
  },
  'weibo_create': {
    link: '/live/weibo/create',
    textKey: 'live_breadcrumb_create',
  },
  'facebook_streams': {
    link: '/live/facebook',
    textKey: 'live_breadcrumb_facebook',
  },
  'facebook_create': {
    link: '/live/facebook/create',
    textKey: 'live_breadcrumb_create',
  },
}

class State {
  @persist
  @observable
  locale = 'en_us';

  @observable
  isMobile

  constructor(root, history) {
    this.root = root;
    this.isMobile = (window && window.innerWidth < 768) || false;
    this.history = history;
  }

  history

  @action
  routePush(url) {
    this.history.push(url);
  }

  @computed
  get langs() {
    return this.locale === 'zh_cn' ? zh_CN : en_US;
  }

  @computed
  get langsAntd() {
    return this.locale === 'zh_cn' ? null : antd_en_US;
  }

  @action
  changeLanguageTo = lang => {
    this.locale = lang;
  };

  @observable
  breadcrumbs = []

  @action
  setBreadcrumbs(arr, platform) {
    this.breadcrumbs = [ breadcrumbItems['home'] ].concat(arr.map((item) => breadcrumbItems[item]))
    this.currentPlatform = platform
  }

  @observable
  currentPlatform
}

export default State;



// WEBPACK FOOTER //
// ./src/store/app.js